<template>
  <div class="dragonshard">
    <van-tabs v-model="active" @click="tabClick" v-show="tab2Arr.length != 0">
      <van-tab v-for="item in tab2Arr" :key="item.id" :title="item.name">
        <div class="dragonshard_listbox">
          <div
            class="dragonshard_list"
            v-for="item in listArr"
            :key="item.ttId"
            @click="detailClick(item.id)"
          >
            <div class="dragonshard_item">
              <div class="dragonshard_itembox">
                <img class="dragonshard_item_bg" :src="item.picture" />
              </div>
              <div class="dragonshard_item_text">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div
      class="dragonshard_listbox dragonshard_listbox2"
      v-show="tab2Arr.length == 0"
    >
      <div
        class="dragonshard_list"
        v-for="item in listArr"
        :key="item.ttId"
        @click="detailClick(item.id)"
      >
        <div class="dragonshard_item">
          <div class="dragonshard_itembox">
            <img class="dragonshard_item_bg" :src="item.picture" />
          </div>
          <div class="dragonshard_item_text">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'listPage',
  props: {
    tab2Arr: {
      type: Array,
      default: () => []
    },
    listArr: {
      type: Array,
      default: () => []
    }
  },
  watch: {},
  data() {
    return {
      active: ''
    };
  },
  methods: {
    tabClick(index) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let id = this.tab2Arr[index].id;
      this.$emit('getList', id);
    },
    //去详情页
    detailClick(id) {
      console.log('2323232');
      this.$router.push({
        name: 'topicPage',
        query: { topicId: id, isGame: 'true' }
      });
    }
  }
};
</script>
<style scoped>
</style>